import { createReducer } from '@reduxjs/toolkit';

import * as actionTypes from '../actionTypes';

/** @typedef {boolean} IsConnectedState */

/** @type {IsConnectedState} */
const initialState = true;

const set = () => true;
const unset = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.CONNECTION_ESTABLISHED, set)
    .addCase(actionTypes.CONNECTION_LOST, unset);
});
